import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", { id: "group-3" }, [
      _createElementVNode("path", {
        id: "vector",
        d: "M14.7917 16.0417H16.9551C17.9242 16.0417 18.7103 15.2074 18.4449 14.2754C17.834 12.1308 16.3908 10.625 14.1667 10.625C13.795 10.625 13.4451 10.6671 13.1173 10.7471M9.37499 5.83333C9.37499 7.3291 8.16243 8.54167 6.66666 8.54167C5.17089 8.54167 3.95833 7.3291 3.95833 5.83333C3.95833 4.33756 5.17089 3.125 6.66666 3.125C8.16243 3.125 9.37499 4.33756 9.37499 5.83333ZM16.4583 6.25C16.4583 7.51565 15.4323 8.54167 14.1667 8.54167C12.901 8.54167 11.875 7.51565 11.875 6.25C11.875 4.98435 12.901 3.95833 14.1667 3.95833C15.4323 3.95833 16.4583 4.98435 16.4583 6.25ZM1.73438 15.105C2.38323 12.4889 4.04904 10.625 6.66666 10.625C9.28428 10.625 10.9501 12.4889 11.5989 15.105C11.832 16.0449 11.0504 16.875 10.082 16.875H3.25131C2.28296 16.875 1.50128 16.0449 1.73438 15.105Z",
        stroke: "currentColor",
        "stroke-width": "1.5",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      })
    ], -1)
  ])))
}
export default { render: render }